var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "OutlookLogo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add-to-Calenar-Modal-10/2022",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-to-your-calendar-modal",
    transform: "translate(-423.000000, -207.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.500000, 87.481475)",
    id: "Save-Button-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(290.500000, 109.639752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OutlookLogo",
    transform: "translate(18.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3793427,4.24037551 L12.3793427,8.15248814 L13.7464789,9.01333333 C13.7825353,9.02384972 13.8606572,9.02460131 13.8967136,9.01333333 L19.7806565,5.04638494 C19.7806565,4.57690127 19.342722,4.24037551 19.0955869,4.24037551 L12.3793427,4.24037551 Z",
    id: "path3",
    fill: "#3D4548",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3793427,9.61201871 L13.6270422,10.4691079 C13.8028169,10.5983098 14.0146479,10.4691079 14.0146479,10.4691079 C13.8035681,10.5983098 19.7814081,6.62760562 19.7814081,6.62760562 L19.7814081,13.8178403 C19.7814081,14.6005634 19.2803752,14.9288262 18.7169954,14.9288262 L12.3785915,14.9288262 L12.3785915,9.61201871 L12.3793427,9.61201871 Z",
    id: "path5",
    fill: "#3D4548",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g23"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.91924883,7.8084507 C5.49408451,7.8084507 5.15530516,8.00826291 4.90516432,8.40713615 C4.65502347,8.80600939 4.52957746,9.33408451 4.52957746,9.9913615 C4.52957746,10.6584038 4.65502347,11.1857277 4.90516432,11.5733333 C5.15530516,11.9616901 5.48356808,12.1547418 5.88920188,12.1547418 C6.30760563,12.1547418 6.63962441,11.9661972 6.88450704,11.589108 C7.12938967,11.2120188 7.25258216,10.6884507 7.25258216,10.0191549 C7.25258216,9.32131455 7.13389671,8.77821596 6.89577465,8.38985915 C6.65765258,8.00225352 6.33239437,7.8084507 5.91924883,7.8084507 Z",
    id: "path25",
    fill: "#3D4548",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,2.25352113 L0,17.5586854 L11.6431925,20 L11.6431925,0 L0,2.25352113 Z M7.79117371,12.4935211 C7.29915493,13.1410329 6.65765258,13.4655399 5.86591549,13.4655399 C5.09446009,13.4655399 4.46647887,13.1515493 3.98046948,12.5243192 C3.49521127,11.896338 3.25183099,11.079061 3.25183099,10.0709859 C3.25183099,9.00657277 3.49821596,8.1457277 3.99173709,7.4884507 C4.48525822,6.83117371 5.13877934,6.50215962 5.95230047,6.50215962 C6.72075117,6.50215962 7.342723,6.81615023 7.81671362,7.4456338 C8.2914554,8.07511737 8.528828,8.90441315 8.528828,9.9342723 C8.52957746,10.9926761 8.28319249,11.8460094 7.79117371,12.4935211 Z",
    id: "path27",
    fill: "#3D4548",
    fillRule: "nonzero"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookLogo);
export default __webpack_public_path__ + "static/media/OutlookLogo.23a82b59aa0281b5593e62b62f4c45da.svg";
export { ForwardRef as ReactComponent };